import React, { lazy, Suspense, useRef, useMemo, useCallback, useContext, } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { Url, URLS } from '@wix/da-url';
import ChatIcon from '@wix/da-ds/pkg/Icons/24x24/Chat';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import VisuallyHidden from '@wix/da-a11y/pkg/components/VisuallyHidden';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import ErrorBoundary from '../../../ErrorBoundary';
import { useIsMounted } from '../../../utils/hooks/useIsMounted';
import throttle from 'lodash/throttle';
import Button from '../../../Button';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
var DesktopChatPanelDropdown = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "chat" */
        '../../../ChatV2/ChatPanel/DesktopChatPanelDropdown');
    });
});
import siteHeaderStyles from '../SiteHeaderDesktop.scss';
import s from './ChatButtonAndDropdown.scss';
import retry from '../../../utils/webpack/chunkRetry';
export var ChatButtonAndDropdown = function (_a) {
    var indicator = _a.indicator, disableDropdown = _a.disableDropdown, disableFloatingChat = _a.disableFloatingChat, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, onOpen = _a.onOpen, onClose = _a.onClose;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var isMounted = useIsMounted();
    var rootRef = useRef(null);
    var enterTimerRef = useRef();
    var throttledMouseLeave = useMemo(function () {
        return throttle(function () {
            clearTimeout(enterTimerRef.current);
            onClose && onClose();
        }, 300);
    }, [onClose]);
    var onMouseEnter = function () {
        enterTimerRef.current = setTimeout(function () {
            onOpen && onOpen();
        }, 100);
    };
    var onTouchEnd = function (e) {
        if (!isOpen) {
            e.preventDefault(); // on touch we noop click
            onOpen && onOpen();
            return;
        }
        onClose && onClose();
    };
    var onClick = function () {
        window.location.assign(Url.buildFromPath(URLS.CHAT_HOME));
    };
    var onClosed = useCallback(function () {
        throttledMouseLeave();
    }, [throttledMouseLeave]);
    if (disableDropdown) {
        return (React.createElement(PlainButtonOrLink, { href: Url.buildFromPath(URLS.CHAT_HOME), className: siteHeaderStyles['icon-button'], biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'chat',
            } },
            React.createElement("span", null,
                React.createElement(ChatIcon, { size: IconSize.MEDIUM, disableDefaultColors: true, className: siteHeaderStyles['chat-icon'] }),
                indicator)));
    }
    return (React.createElement("div", { className: classnames(s['root'], siteHeaderStyles['icon-button-has-submenu'], siteHeaderStyles['icon-button-has-chat-submenu']), onMouseEnter: onMouseEnter, onMouseLeave: onClosed, ref: rootRef },
        !isMobile && (React.createElement(Button, { view: "b3", className: s['a11y-toggle'], "aria-haspopup": true, "aria-expanded": isOpen, "aria-controls": "site-header-chat", onClick: isOpen ? onClose : onOpen }, t('siteHeader.chat.open'))),
        React.createElement(PlainButtonOrLink, { onTouchEnd: onTouchEnd, onClick: onClick, className: classnames(siteHeaderStyles['icon-button'], isOpen && siteHeaderStyles['toggled']), 
            // This button is in a weird spot. On desktop, it's only responsibility is
            // linking to the chat standalone page. On mobile, it opens a modal. So
            // mark as a link on desktop.
            role: isMobile ? undefined : 'link', biData: {
                evid: BiEventType.TOP_NAV_CLICK,
                link_name: 'chat',
            } },
            React.createElement("span", null,
                React.createElement(ChatIcon, { size: IconSize.MEDIUM, disableDefaultColors: true, className: siteHeaderStyles['chat-icon'] }),
                indicator,
                React.createElement(VisuallyHidden, null, t('chat.panel.a11y.chatButtonLink')))),
        React.createElement(ErrorBoundary, null, isMounted && isOpen && (React.createElement(Suspense, { fallback: null },
            React.createElement(DesktopChatPanelDropdown, { id: "site-header-chat", className: classnames(s['dropdown'], isOpen && s['open'], s['a11y-dropdown']), disableFloatingChat: disableFloatingChat, onClose: onClosed }))))));
};
ChatButtonAndDropdown.displayName = 'ChatButtonAndDropdown';
export default ChatButtonAndDropdown;
//# sourceMappingURL=ChatButtonAndDropdown.js.map